import "./Pagination.css";

const Pagination = ({
  totalPages = 0,
  currentPage = 0,
  onPageChange = () => {},
}) => {
  if (totalPages <= 0) return null;

  const getPaginationRange = () => {
    const range = [];

    const isStartRange = currentPage <= 4;
    const isEndRange = currentPage >= totalPages - 3;

    if (isStartRange) {
      // Show first 5 pages, ellipsis, and last
      for (let i = 1; i <= Math.min(5, totalPages); i++) {
        range.push(i);
      }
      if (totalPages > 6) {
        range.push("...");
        range.push(totalPages);
      } else if (totalPages === 6) {
        range.push(6);
      }
    } else if (isEndRange) {
      // Show first, ellipsis, and last 5 pages
      range.push(1);
      if (totalPages > 6) {
        range.push("...");
      }
      for (let i = totalPages - 4; i <= totalPages; i++) {
        if (i > 1) range.push(i);
      }
    } else {
      // Show first, ellipsis, 2 pages before/after current, ellipsis, last
      range.push(1);
      range.push("...");
      for (let i = currentPage - 2; i <= currentPage + 2; i++) {
        if (i > 1 && i < totalPages) range.push(i);
      }
      range.push("...");
      range.push(totalPages);
    }

    return range;
  };

  const paginationRange = getPaginationRange();

  const handleClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      onPageChange(page);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="pagination-container flex-wrap">
      <button
        className="pagination-button nav"
        onClick={handlePrev}
        disabled={currentPage === 0}
      >
        Prev
      </button>
      {paginationRange.map((page, index) => (
        <button
          key={index}
          className={`pagination-button ${
            page - 1 === currentPage ? "active" : ""
          } ${page === "..." ? "disabled" : ""}`}
          onClick={() => handleClick(page - 1)}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}
      <button
        className="pagination-button nav"
        onClick={handleNext}
        disabled={currentPage === totalPages - 1}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
